var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.locationImg)?_c('div',{staticClass:"operate-location"},[_c('div',{ref:"operateLocation",staticClass:"operate-location__image",class:{ 'operate-location__cursor': _vm.locationUrl },style:({ backgroundImage: ("url(" + _vm.locationImg + ")") }),on:{"click":function($event){return _vm.handleOperateLocation($event)}}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f2c9d5b","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NewCourseDetail/modules/OperateLocation.vue
// module id = 1165
// module chunks = 1